import React from 'react';

interface PaymentMethodsRowProps {
  variant?: 'default' | 'compact';
  align?: 'left' | 'center' | 'right';
  className?: string;
}

export default function PaymentMethodsRow({ 
  variant = 'default', 
  align = 'center',
  className = '' 
}: PaymentMethodsRowProps) {
  const alignClass = {
    left: 'items-start',
    center: 'items-center',
    right: 'items-end',
  }[align];

  // Visa icon
  const VisaIcon = () => (
    <img 
      src="https://genanything-assets.s3.us-east-1.amazonaws.com/upgrade-assets/visa-svgrepo-com.svg" 
      alt="Visa" 
      className="h-4 sm:h-5 w-auto"
    />
  );

  // Mastercard icon
  const MastercardIcon = () => (
    <img 
      src="https://genanything-assets.s3.us-east-1.amazonaws.com/upgrade-assets/mastercard-svgrepo-com.svg" 
      alt="Mastercard" 
      className="h-4 sm:h-5 w-auto"
    />
  );

  // American Express icon
  const AmexIcon = () => (
    <img 
      src="https://genanything-assets.s3.us-east-1.amazonaws.com/upgrade-assets/American+Express_Symbol_0.svg" 
      alt="American Express" 
      className="h-4 sm:h-5 w-auto"
    />
  );

  // Apple Pay icon
  const ApplePayIcon = () => (
    <img 
      src="https://genanything-assets.s3.us-east-1.amazonaws.com/upgrade-assets/apple-pay-svgrepo-com-WHITE.svg" 
      alt="Apple Pay" 
      className="h-4 sm:h-5 w-auto"
    />
  );

  // Google Pay icon
  const GooglePayIcon = () => (
    <img 
      src="https://genanything-assets.s3.us-east-1.amazonaws.com/upgrade-assets/google-pay-primary-logo-logo.svg" 
      alt="Google Pay" 
      className="h-4 sm:h-5 w-auto"
    />
  );

  return (
    <div className={`flex flex-col ${alignClass} ${className} mb-6`}>
      {/* Label */}
      <div className="text-[11px] sm:text-xs text-white/60 mb-1.5 sm:mb-2 text-center">
        Debit or Credit Card
      </div>
      
      {/* Icons Row */}
      <div className={`flex flex-wrap items-center justify-center gap-1.5 sm:gap-2`}>
        <div className="flex items-center justify-center opacity-75 hover:opacity-100 transition-opacity h-4 sm:h-5">
          <VisaIcon />
        </div>
        <div className="flex items-center justify-center opacity-75 hover:opacity-100 transition-opacity h-4 sm:h-5">
          <MastercardIcon />
        </div>
        <div className="flex items-center justify-center opacity-75 hover:opacity-100 transition-opacity h-4 sm:h-5">
          <AmexIcon />
        </div>
        <div className="flex items-center justify-center opacity-75 hover:opacity-100 transition-opacity h-4 sm:h-5">
          <ApplePayIcon />
        </div>
        <div className="flex items-center justify-center opacity-75 hover:opacity-100 transition-opacity h-4 sm:h-5">
          <GooglePayIcon />
        </div>
      </div>
    </div>
  );
}

